module.exports = __webpack_public_path__ + "static/media/w (26).f239b284.jpg";